// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/common/type/v1/user_profile.proto (package fingertip.common.type.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { UserRole } from "../../enum/v1/user_role_pb.js";
import { Asset } from "./asset_pb.js";

/**
 * @generated from message fingertip.common.type.v1.UserProfile
 */
export const UserProfile = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.UserProfile",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "business_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "job_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "avatar_asset_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "role", kind: "enum", T: proto3.getEnumType(UserRole) },
    { no: 9, name: "stripe_customer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "default_payment_method_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "default_billing_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "default_shipping_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "time_zone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "created_at", kind: "message", T: Timestamp },
    { no: 18, name: "updated_at", kind: "message", T: Timestamp },
    { no: 19, name: "klaviyo_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "hubspot_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "date_of_birth", kind: "message", T: Timestamp },
    { no: 22, name: "pronouns", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 23, name: "gender", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 24, name: "avatar_asset", kind: "message", T: Asset },
    { no: 25, name: "cello_ucc", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 26, name: "avatar_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

